<template>
  <div class="service-process">
    <z-list v-if="serviceList.length" v-model="loading" :finished="finished" @load="onLoad">
      <div class="service-process-wrap" v-for="(item, idx) in serviceList" :key="idx">
        <process-item :info="item"></process-item>
      </div>
    </z-list>
    <div class="no-list" v-if="!serviceList.length && !loading">
      <z-stance type="general" :show-info="false" descText="暂无服务"></z-stance>
    </div>
  </div>
</template>

<script>
import { lego } from '@zz-common/lego'
import native from '@zz-common/native-adapter'
import { List, Stance } from '@zz-common/zz-ui'
import { getTicketsForUser } from '@api/resourceApi'
import ProcessItem from '../components/process-item/index'
import { getCookie } from '../../../lib/utils'

export default {
  name: 'ServiceProcess',
  components: {
    'z-list': List,
    'z-stance': Stance,
    ProcessItem
  },
  data() {
    return {
      loading: true, // 列表是否正在加载
      finished: false, // 列表是否加载完成
      pageNum: 1,
      serviceList: [], // 列表数据
      isLogin: false
    }
  },
  created() {
    native.setTitle({
      title: '服务进度'
    })
  },
  mounted() {
    // 改用native提供的login
    native.login(() => {
      this.isLogin = true
      this.getUserServiceInfo()
      lego.send({
        pagetype: 'ZZKF_C_TICKET_SERVICE_LIST',
        actiontype: 'PAGE_SHOW'
      })
    })
  },
  methods: {
    onLoad() {
      if (!this.isLogin) {
        this.loading = false
        return
      }
      this.getUserServiceInfo()
    },
    async getUserServiceInfo() {
      const uid = getCookie('uid') || ''
      const params = {
        uid,
        pageSize: 10,
        pageNum: this.pageNum++
      }
      const res = await getTicketsForUser(params)
      this.loading = false
      console.log(res)
      if (res.length <= 0) {
        this.finished = true
        return
      }
      this.serviceList = this.serviceList.concat(res)
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
